module.exports = __webpack_public_path__ + "img/log-out-03.9f3e3b36.svg";